"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./activity.scss");

var _ActivityTooltip = _interopRequireDefault(require("./ActivityTooltip"));

const ActivityItemLabel = props => {
  const {
    label,
    tooltip
  } = props;
  return /*#__PURE__*/_react.default.createElement("span", null, label, ' ', tooltip && /*#__PURE__*/_react.default.createElement(_ActivityTooltip.default, {
    text: tooltip
  }));
};

var _default = ActivityItemLabel;
exports.default = _default;